/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './style.scss';

const Row = ({ className, noWrap, children, ...restProps }) => {
  const classes = classnames(styles.row, className, {
    [styles.noWrap]: noWrap,
  });
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

Row.defaultProps = {};

Row.propTypes = {
  className: PropTypes.string,
};

export default Row;
